document.addEventListener("DOMContentLoaded", _ => {
    if (document.getElementById("aanmeldSelectionForm")) {
        chooseAanmeldLink();
    }

})

let chooseAanmeldLink = function () {
    let $form = document.getElementById("aanmeldSelectionForm");
    let $buttons = $form.querySelectorAll(".aanmeldSelectionForm__button");
    let $leerweg = $form.leerweg.value || "false";
    let $locatie = $form.locatie.value || "false";

    
    let aanmeldUrl = Array.from(document.querySelectorAll('button.btn[data-leerweg]:not([disabled])'))

    if(event.target.name === 'leerweg'){
        let locatieOpties = Array.from(document.querySelectorAll('select[name=locatie] option:not([value=false])'))
        locatieOpties.forEach(item => {
            item.style.display = 'none'
        })

        let locatieLeerweg = aanmeldUrl.filter(item =>{
            return item.getAttribute('data-leerweg') === event.target.value && item.getAttribute('data-url')
        })

        locatieLeerweg.forEach(item =>{
            document.querySelector('select[name=locatie] option[value='+item.getAttribute('data-locatie')+']').style.display = ''
        })
    }


    for (let i = 0; i < $buttons.length; i++) {
        $buttons[i].classList.remove("show");
    }


    let $button = ($form.leerweg.value != "false" && $form.locatie.value != "false") ? $form.querySelector(`.aanmeldSelectionForm__button[data-leerweg='${$leerweg}'][data-locatie='${$locatie}']`) : $form.querySelector(`.aanmeldSelectionForm__button[data-leerweg='false'][data-locatie='false']`);

    $button.classList.add("show")
}